import { UcoastEl } from '@/scripts/core/UcoastEl'
import {TsDOM as q} from '@/scripts/core/TsDOM'

export class UcoastSelect extends UcoastEl {
	static htmlSelector = 'ucoast-select'
	select?: HTMLSelectElement
	optionButtons?: NodeListOf<HTMLButtonElement>
	optionPanel: HTMLElement
	closeListener: (e: MouseEvent) => void
	triggerEl: HTMLButtonElement | HTMLSelectElement
	eventType: 'change' | 'input'

	constructor() {
		super()
		this.select = q.os('select', this)
		this.eventType = this.getAttribute('data-event-type') === 'input' ? 'input' : 'change'
		this.optionButtons = q.ol('button[data-value]', this)
		this.optionPanel = q.rs('[data-option-panel]', this)
		this.triggerEl = q.rs('[data-trigger]', this)
		this.triggerEl.addEventListener('click', this.openOptions.bind(this))
		this.select?.addEventListener(this.eventType, this.onChange.bind(this))
		this.optionButtons?.forEach((button) => {
			button.addEventListener('click', (e) => {
				const currentTarget = q.rct(e)
				const value = q.ra(currentTarget, 'data-value')
				this.setValue(value)
				const label = q.rs('span', currentTarget).innerHTML
				this.setLabel(label)
				this.updateActiveClasses(value)
			})
		})
		this.closeListener = this.handleOutsideClick.bind(this)
		this.triggerEl.setAttribute('aria-haspopup', 'dialog')
		this.triggerEl.setAttribute('aria-expanded', 'false')
	}

	onChange(event: Event) {
		const el = event.target as HTMLSelectElement
		const value = el.value
		const eventChange = new CustomEvent(this.eventType, {
			detail: { value },
			bubbles: true,
		})
		this.dispatchEvent(eventChange)
	}

	openOptions() {
		if (this.triggerEl.getAttribute('aria-expanded') === 'true') {
			this.closeOptions()
			return
		}
		this.optionPanel.setAttribute('aria-hidden', 'false')
		this.triggerEl.setAttribute('aria-expanded', 'true')
		document.body.addEventListener('click', this.closeListener)
		window.TsDOM.trapFocus(this.optionPanel)
	}

	closeOptions() {
		this.optionPanel.classList.remove('open')
		this.optionPanel.setAttribute('aria-hidden', 'true')
		this.triggerEl.setAttribute('aria-expanded', 'false')
		document.body.removeEventListener('click', this.closeListener)
		window.TsDOM.removeTrapFocus(this.triggerEl)
	}

	handleOutsideClick(event: MouseEvent) {
		if (!this.contains(event.target as Node)) {
			this.closeOptions()
		}
	}
	setLabel(label: string) {
		const labelEl = q.rs('[data-label]', this)
		labelEl.innerHTML = label
	}

	updateActiveClasses(value: string) {
		if (!this.optionButtons) return
		this.optionButtons.forEach(el => {
			const currentVal = q.ra(el, 'data-value')
			if (currentVal === value) {
				el.classList.remove('underline-on-hover-child')
				el.classList.add('underline-always-child')
				el.setAttribute('data-selected', '')
			} else {
				el.classList.remove('underline-always-child')
				el.classList.add('underline-on-hover-child')
				el.removeAttribute('data-selected')
			}
		})
	}

	setValue(value: string) {
		if (!this.select) {
			this.closeOptions()
			return;
		}
		if (this.select.value !== value) {
			this.select.value = value
			const event = new Event(this.eventType, { bubbles: true })
			this.select.dispatchEvent(event)
		}
		this.closeOptions()
	}
}
